<ng-template #modal let-modal>
    <div class="modal-header bg-light pb-1">
        <h4 class="modal-title ">{{ 'home.productHeader.counterOffer' | cxTranslate }}</h4>
        <h6 class="modal-title modalsubheader">{{ 'home.productHeader.You' | cxTranslate }}</h6>
    </div>
    <div class="modal-body bg-light">
        <!-- <hr class="hr-border"> -->
        <div>
            <span class="mr-1 h5-strong line-clamp-single text-center pb-2">{{productInfo.quoteEntries[0].productName }}</span>
        </div>
        <div>
            <span class="text-secondary line-clamp-single mt-1 h5 text-center">{{productInfo.quoteEntries[0].portName}}</span>
        </div>
        <div class="d-flex justify-content-mobile-between mt-2">
            <div class="col-6 p-0 small">
                <div class="pb-1 small strong">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}*</div>
                <div>
                    <span class="currency-icon position-absolute">¥&nbsp;</span>
                    <input [(ngModel)]="priceValue" class="form-control form-control-lg modal-input-field strong pl-4" (keypress)="checkPriceValidation($event);validateDecimalPointPrice($event)" appTwoDigitDecimaNumber onkeypress="return event.charCode != 45" preventCutCopyPaste required [ngClass]="!modalfocus? 'focus' : ''">
                </div>
                <span class=" text-danger bold fs-10 " *ngIf='priceValue == 0 '>{{ 'home.productHeader.enterprice' | cxTranslate }}</span>
                <!-- <span class="text-danger fs-10" *ngIf='priceValue < minPrice'>{{placemsg}}</span> -->
            </div>
            <div class="col-6 p-0 small quantity-width">
                <div class="pb-1 small strong">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
                <div class="right-alignment"  *ngIf="!showquantity">
                    <select [(ngModel)]="quantitySelected" class="round bg-white border p-2 select-width">
              <option value="{{p}}" *ngFor="let p of quantityRangeArray">{{p}}</option>
            </select>
                </div>
                <div class="right-alignment"  *ngIf="showquantity">
                    <select [(ngModel)]="actualQuantitySelected" class="round bg-white border p-2 select-width">
              <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
            </select>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <p class="mb-2 small strong">{{ 'home.productHeader.bindingTerms' | cxTranslate }}</p>
            <textarea class="w-100 text border" maxlength="5000" placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}" [(ngModel)]="biddingTerms"></textarea>
        </div>
        <div class="d-flex justify-content-mobile-between mt-2">
            <div class="col-6 p-0 small">
                <div class="pb-2 small strong">{{ 'home.productHeader.validityDate' | cxTranslate }}*:</div>
                <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to">
                    <fieldset>
                        <!--<date-range-picker [instanceId]="'secondDateRange'" [options]="secondFieldOptions" [parentFormGroup]="form" [controlName]="'secondDateRange'" (rangeSelected)="onRangeSelected($event)" (datepickerReset)="onReset($event)" #dateRangePicker>
                            <div class="form-group">
                                <div class="input-group"> 
                                    <div class="input-group-prepend">
                                    </div>
                                    <input id="secondDateRange" class="form-control form-control-lg bg-white  ff-normal h-40" type="text" [value]="dateRangePicker.range" [(ngModel)]="dateSelected" placeholder="{{ 'home.productHeader.selectDate' | cxTranslate }}" formControlName="secondDateRange" readonly/>
                                </div>
                            </div>
                        </date-range-picker>-->
                        <input type="text"  ngbDatepicker class="form-control form-control-lg bg-white  ff-normal h-40 date-width" #d="ngbDatepicker"  [footerTemplate]="footerTemplate" (dateSelect)="onDateSelection($event)" [value]=formatter.format(startDate?startDate:today) (click)="toggle(d)" />
                        <ng-template #footerTemplate>
                            <hr class="my-0">
                            <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="d.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                        </ng-template>
                    </fieldset>
                </form>

            </div>

            <div class="col-6 p-0 small">
                <div class="pb-1 small strong ml-0">{{ 'home.productHeader.validityTime' | cxTranslate }}*:</div>
                <div class="right-alignment">
                    <select [(ngModel)]="timeSelected" (change)="selectTimeFunction()" class="round  bg-white border p-2 timeSelect  ff-normal select-width">
              <option value="{{p}}" *ngFor="let p of timeArray">{{p}}</option>
            </select>
                </div>
            </div>
        </div>
        <!-- <span *ngIf="!showDateError" class="modalDateError">Please select Date</span> -->
        <div class="small">{{ 'home.productHeader.timeZone' | cxTranslate }} </div>
        <!-- <hr class='hr-border'> -->
        <div *ngIf="counterOfferError" class="text-danger text-center mt-3 strong ">{{counterOfferErrorValue}}</div>
    </div>
    <div class="modal-footer bg-light">
        <div class="form-group">
            <!-- <button class="btn btn-block btn-primary" type="submit" (click)="editQuote(productInfo);homeLinkClick(false)" data-dismiss="modal" [disabled]="startDate ==null || disabledBtn || priceValue =='' || priceValue == 0 || priceValue < minPrice "> -->
                <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="editQuote(productInfo);homeLinkClick(false)" data-dismiss="modal" [disabled]="startDate ==null || disabledBtn || priceValue =='' || priceValue == 0">
          {{ 'home.productHeader.ConfirmBid' | cxTranslate }}
        </button>
            <button class="btn btn-block btn-secondary btn-lg" type="submit" (click)="close()" data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
        </div>
    </div>
</ng-template>